import React from "react"
import PropTypes from "prop-types"
import {Helmet} from "react-helmet"
//import { useLocation } from "@reach/router"
import { useStaticQuery, graphql } from "gatsby"

const SEO = ({title, description}) => {
  //const { pathname } = useLocation()
  const { site } = useStaticQuery(query)
  const {
    defaultTitle,
    titleTemplate,
    defaultDescription,
    url,
    siteName,
    pageType,
    image,
  } = site.siteMetadata

  const seo = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    url: url,
    pageType: pageType,
    siteName: siteName,
    image: image || url + '/ogp.png',
  }

  return (
    <Helmet
      title={seo.title}
      titleTemplate={title ? titleTemplate : null}
    >
      <html lang="ja"/>
      <meta charSet="utf-8"/>
      <meta name="description" content={cleanHtmlTag(seo.description)}/>
      {seo.url && <meta property="og:url" content={seo.url} />}
      {seo.pageType && <meta property="og:type" content={seo.pageType} />}
      {seo.title && <meta property="og:title" content={seo.title} />}
      {seo.description && <meta property="og:description" content={seo.description} />}
      {seo.siteName && <meta property="og:site_name" content={seo.siteName} />}
      {seo.image && <meta property="og:image" content={seo.image} />}
    </Helmet>
  )
}

export default SEO

SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
}

SEO.defaultProps = {
  title: null,
  description: null,
}

const query = graphql`
  query SEO {
    site {
      siteMetadata {
        defaultTitle: title
        titleTemplate
        defaultDescription: description
        url
        siteName
        pageType
        image
      }
    }
  }
`

const cleanHtmlTag = (html) => html.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g, "")